import resources from "../../core/Localization/Localization";
import { historyLogTypes } from "../../variables/historyLogTypes";
import { getDateString } from "../../utils/getDateString";


export const historyLogColumns = () => [
    {
        field: "id",
        headerName: resources.historyLogs.datagrid.id,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "action",
        headerName: resources.historyLogs.datagrid.action,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "model_id",
        headerName: resources.historyLogs.datagrid.modelId,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "type",
        headerName: resources.historyLogs.datagrid.type,
        filter: true,
        sort: true,
        filterType: "dropdown",
        filterOptions: {
            names: Object.values(historyLogTypes),
            renderValue: (v) => resources.historyLogs.type[v].toUpperCase(),
        },
        customFilterListOptions: { render: (v) => `${resources.historyLogs.datagrid.type}: ${resources.historyLogs.type[v].toUpperCase()}` },
        flex: 1
    },
    {
        field: "path",
        headerName: resources.historyLogs.datagrid.path,
        filter: true,
        sort: true,
        filterType: "textField",
    },
    {
        field: "createdAt",
        headerName: resources.partRequests.datagrid.created,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1,
        valueGetter: (value) => getDateString(value)
    }
];
